import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { DatePicker } from "rsuite";
import {
  createSession,
  getSession,
  getSessionSearch,
  getSessionType,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDate } from "../../../utils/helperFunction";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Session", sortingVale: "name" },
  { heading: "Session Type", sortingVale: "education" },
  { heading: "Start Time", sortingVale: "startTime" },
  { heading: "End Time", sortingVale: "endTime" },
  { heading: "Effective Date", sortingVale: "effectiveDate" },
  { heading: "Comment", sortingVale: "comment" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const AllSession = () => {
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [sessionData, setSessionData] = useState([]);
  const [sessionType, setSessionType] = useState([]);
  const [selectedSessionType, setSelectedSessionType] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("ACTIVE");
  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    sessionName: "",
    startTime: "",
    endTime: "",
    effectiveDate: "",
    comment: "",
    status: "ACTIVE",
  });

  const statusOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  function SotingData(name) {
    const sortedPeople = [...sessionData];
    switch (name) {
      case "packageType":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.packageType.localeCompare(b.packageType)
            : b.packageType.localeCompare(a.packageType);
        });
        break;
      case "amount":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.amount.localeCompare(b.amount)
            : b.amount.localeCompare(a.amount);
        });
        break;
      case "effectiveDate":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.effectiveDate.localeCompare(b.effectiveDate)
            : b.effectiveDate.localeCompare(a.effectiveDate);
        });
        break;
      default:
        break;
    }
    setSessionData(sortedPeople);
  }

  useEffect(() => {
    fetchSessionType();
  }, []);

  useEffect(() => {
    fetchSession();
  }, [search, status]);

  async function fetchSession() {
    try {
      const res = await getSessionSearch(search, status);
      setSessionData(res || []);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchSessionType() {
    try {
      const res = await getSessionType();
      setSessionType(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  function DataSearch(e) {
    const updatesDate = sessionData.filter((item) => {
      let selectdata =
        `${item.sessionType} ${item.sessionName} ${item.startTime} ${item.endTime}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setSessionData([...updatesDate]);
  }

  const validate = () => {
    const newErrors = {};

    if (!formData.sessionName.trim())
      newErrors.sessionName = "Session Name is required";
    if (!formData.effectiveDate)
      newErrors.effectiveDate = "Effective Date is required";
    if (!formData.startTime) newErrors.startTime = "Start Time is required";
    if (!formData.endTime) newErrors.endTime = "End Time is required";
    if (!selectedSessionType)
      newErrors.sessionType = "Session Type is required";
    if (!formData.comment.trim()) newErrors.comment = "Comment is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    const payload = {
      name: formData.sessionName,
      sessionTypeId: selectedSessionType.value,
      startTime: formData.startTime + ":00", // Convert "14:30" to "14:30:00"
      endTime: formData.endTime + ":00", // Convert "14:30" to "14:30:00"
      effectiveDate: formData.effectiveDate, // already "YYYY-MM-DD"
      comment: formData.comment,
      status: formData.status,
    };

    // If editing, include id
    if (editingId) {
      payload.id = editingId;
    }

    try {
      const res = await createSession(payload);
      if (res) {
        toast.success(
          editingId
            ? "Updated Session successfully!"
            : "Created Session successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        fetchSession();
        handleCancel();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    setSelectedSessionType(null);
    setFormData({
      sessionName: "",
      startTime: "",
      endTime: "",
      effectiveDate: "",
      comment: "",
      status: "ACTIVE",
    });
    setEditingId(null);
  };

  return (
    <>
      <PageTitle activeMenu={"All Session"} motherMenu={"Sessions"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                Session {editingId ? "Updation" : "Creation"}
              </h5>
            </div>

            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="endDate">
                        Session Name <span className="required">*</span>
                      </label>
                      <input
                        id="Enter_Session_Name"
                        name="sessionName"
                        placeholder="Enter Session Name"
                        type="text"
                        value={formData.sessionName}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.sessionName ? "is-invalid" : ""
                        }`}
                        required
                      />
                      {errors.sessionName && (
                        <small className="text-danger m-lg-2">
                          {errors.sessionName}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Name of the Student */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="studentName">
                        Session Type <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        value={selectedSessionType}
                        options={sessionType?.map((type) => ({
                          value: type.id,
                          label: type.name,
                        }))}
                        onChange={(d) => {
                          setSelectedSessionType(d);
                          setErrors((prev) => ({
                            ...prev,
                            sessionType: "",
                          }));
                        }}
                        placeholder="Select Session Type"
                        className="custom-react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.sessionType
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.sessionType
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.sessionType
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.sessionType && (
                        <small className="text-danger m-lg-2">
                          {errors.sessionType}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Start Time */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="startTime">
                        Start Time <span className="required">*</span>
                      </label>
                      <input
                        id="startTime"
                        name="startTime"
                        type="time"
                        className={`form-control ${
                          errors.startTime ? "is-invalid" : ""
                        }`}
                        value={formData.startTime}
                        onChange={handleChange}
                        required
                      />
                      {errors.startTime && (
                        <small className="text-danger m-lg-2">
                          {errors.startTime}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* End Time */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="endTime">
                        End Time <span className="required">*</span>
                      </label>
                      <input
                        id="endTime"
                        name="endTime"
                        type="time"
                        className={`form-control ${
                          errors.endTime ? "is-invalid" : ""
                        }`}
                        value={formData.endTime}
                        onChange={handleChange}
                        required
                      />
                      {errors.endTime && (
                        <small className="text-danger m-lg-2">
                          {errors.endTime}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Effective Date <span className="required">*</span>
                      </label>

                      <div className="input-hasicon mb-xl-0 mb-3">
                        <DatePicker
                          placeholder="Select Effective Date"
                          className="picker-suit"
                          value={
                            formData.effectiveDate
                              ? new Date(formData.effectiveDate)
                              : null
                          }
                          onChange={(date) => {
                            setFormData((prev) => ({
                              ...prev,
                              effectiveDate: date ? formatDate(date) : "",
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              effectiveDate: "",
                            }));
                          }}
                          style={{
                            borderColor: errors.effectiveDate ? "#dc3545" : "",
                          }}
                        />

                        <div className="icon">
                          <i className="far fa-calendar" />
                        </div>
                      </div>

                      {errors.effectiveDate && (
                        <small className="text-danger m-lg-2">
                          {errors.effectiveDate}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="comment">
                        Comment <span className="required">*</span>
                      </label>
                      <input
                        id="comment"
                        name="comment"
                        placeholder="Enter Comment"
                        type="text"
                        value={formData.comment}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.comment ? "is-invalid" : ""
                        }`}
                        required
                      />
                      {errors.comment && (
                        <small className="text-danger m-lg-2">
                          {errors.comment}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Status<span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={statusOptions}
                        placeholder="Select Status"
                        className="custom-react-select"
                        value={statusOptions.find(
                          (option) => option.value === formData.status,
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            status: selected?.value || "ACTIVE",
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading
                        ? editingId
                          ? "Updating..."
                          : "Submitting..."
                        : editingId
                          ? "Update"
                          : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            {/* <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav> */}
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Session List </h4>
                    <div className="d-flex align-items-center">
                      <span className="me-3 fw-semibold">Active/Inactive</span>

                      <button
                        type="button"
                        className={`status-switch ${status === "ACTIVE" ? "active" : ""}`}
                        onClick={() =>
                          setStatus(status === "ACTIVE" ? "INACTIVE" : "ACTIVE")
                        }
                      >
                        <span className="switch-text">
                          {status === "ACTIVE" ? "ON" : "OFF"}
                        </span>
                        <span className="switch-circle"></span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length"></div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {sessionData?.map((data, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{data?.name}</td>
                                <td>{data?.sessionType?.name}</td>
                                <td>{data?.startTime}</td>
                                <td>{data?.endTime}</td>
                                <td>{data?.effectiveDate}</td>
                                <td>{data?.comment}</td>
                                <td>{data?.status}</td>

                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-s sharp btn-primary me-1"
                                    onClick={() => {
                                      setEditingId(data.id);
                                      setSelectedSessionType({
                                        value: data?.sessionType?.id,
                                        label: data?.sessionType?.name,
                                      });

                                      // Convert "14:30:00" to "14:30" for time input
                                      const startTime = data.startTime
                                        ? data.startTime.substring(0, 5)
                                        : "";
                                      const endTime = data.endTime
                                        ? data.endTime.substring(0, 5)
                                        : "";

                                      setFormData({
                                        sessionName: data.name || "",
                                        startTime: startTime,
                                        endTime: endTime,
                                        effectiveDate: data.effectiveDate || "",
                                        comment: data.comment || "",
                                        status: data.status || "ACTIVE",
                                      });
                                      setErrors({});
                                    }}
                                  >
                                    <i className="fa fa-pencil" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default AllSession;
